import { go, routeUrl, useStore, type Route } from "./store";
import { desktopBadge, desktopNotify, isDesktop } from "./desktop";
import { playSound } from "./sounds";

// Like Slack: every message from someone else notifies, unless you're looking at that chat.

export const canNotify = () => "Notification" in window;
export const notifyState = () => (canNotify() ? Notification.permission : "denied");
export async function askNotify() { if (canNotify() && Notification.permission === "default") await Notification.requestPermission(); }

const looking = (r: Route) => {
  const cur = useStore.getState().route;
  if (!document.hasFocus() || document.visibilityState !== "visible") return false;
  if (r.v === "room" && cur.v === "room") return cur.id === r.id && (!r.thread || cur.thread === r.thread);
  if (r.v === "task" && cur.v === "task") return cur.id === r.id;
  return false;
};

const PAUSE = "hub:pause-until";
export const pausedUntil = () => { try { return Number(localStorage.getItem(PAUSE) || 0); } catch { return 0; } };
export const pauseNotifications = (until: number) => { try { until ? localStorage.setItem(PAUSE, String(until)) : localStorage.removeItem(PAUSE); } catch {} };

/** Your own sound and volume (profile card). */
export function knock() {
  const me = useStore.getState().me;
  if (me) playSound(me.sound ?? "twotone", me.volume ?? 0.5);
}

export function notify(title: string, body: string, route: Route, tag?: string, always = false) {
  if (!always && (looking(route) || pausedUntil() > Date.now())) return;
  knock();
  // Grouped per chat in Notification Centre, like Slack.
  if (isDesktop()) return desktopNotify(title, body.slice(0, 180), routeUrl(route), route.v === "room" ? `room-${route.id}` : route.v);
  if (!canNotify() || Notification.permission !== "granted") return;
  const n = new Notification(title, { body: body.slice(0, 180), tag, icon: "/favicon.svg" });
  n.onclick = () => { window.focus(); go(route); n.close(); };
}

/** Unread count in the tab title and on the tab icon. */
export function keepBadge() {
  const icon = document.querySelector<HTMLLinkElement>('link[rel="icon"]')!;
  const base = icon.href;
  let last = -1;
  useStore.subscribe((s) => {
    // The badge counts chats set to "all", plus @mentions anywhere.
    const n = Object.values(s.states).reduce((a, x) => a + (!s.rooms[x.roomId] ? 0 : x.notify === "all" ? x.unread : x.mentions), 0)
      + Object.values(s.follows).filter((f) => f.lastReplyId > f.lastReadId && s.states[f.roomId]?.notify !== "none").length;
    if (n === last) return;
    last = n;
    document.title = n ? `(${n}) Rockenue Hub` : "Rockenue Hub";
    desktopBadge(n);
    if (!n) { icon.href = base; return; }
    const c = document.createElement("canvas"); c.width = c.height = 64;
    const g = c.getContext("2d")!;
    g.fillStyle = "#f3f5f7"; g.beginPath(); g.roundRect(0, 0, 64, 64, 16); g.fill();
    g.fillStyle = "#0a0f1a"; g.font = "700 36px Inter, Arial"; g.textAlign = "center"; g.fillText("R", 30, 45);
    g.fillStyle = "#fb7185"; g.beginPath(); g.arc(50, 14, 14, 0, 7); g.fill();
    icon.href = c.toDataURL();
  });
}
